import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useServiceCatalog } from './ServiceCatalogContext';
import ProductCard from './ProductCard';

const ProductsContainer = styled.section`
  padding: 3rem 0;
  background-color: #f8f9fa;
`;

const ProductsWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto; 
  padding: 0 2rem;
`;


const SectionTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2.5rem;
  color: #333;
`;

const CarouselContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 1.5rem;
  padding: 1rem 0;
  /* Make it behave like a slider on mobile */
  /* Hide scrollbar on mobile for a cleaner look */
  @media (max-width: 768px) {
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar { display: none; } /* Chrome, Safari, Opera */
  }
  /* Style the scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #ccc #f8f9fa;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f8f9fa;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
    border: 2px solid #f8f9fa;
  }
`;

const CardWrapper = styled.div`
  min-width: 280px; /* Ensure cards have a minimum width on desktop */
  display: flex; /* Allow ProductCard to stretch to full height */

  @media (max-width: 768px) {
    scroll-snap-align: start;
    flex: 0 0 90%; /* Each card takes up 90% of the container width */
    max-width: 320px; /* But not more than 320px */
    &:first-child {
      margin-left: 2rem; /* Add initial margin only for the first item */
    }
  }
`;

const SeeAllButtonContainer = styled.div`
  text-align: center;
  margin-top: 2.5rem;
`;

const SeeAllButton = styled(Link)`
  display: inline-block;
  background-color: transparent;
  color: #005eb8;
  border: 2px solid #005eb8;
  padding: 0.8rem 2.5rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #005eb8;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Content = () => {
  const { allServices } = useServiceCatalog();
  // For demonstration, we'll show the first 5 services as "popular".
  const popularProducts = allServices.slice(0, 5);
  return (
    <ProductsContainer>
      <ProductsWrapper>
        <SectionTitle>Popular Products & Services</SectionTitle>
        <CarouselContainer>
          {popularProducts.map((product) => (
            <CardWrapper key={product.id}>
              <ProductCard service={product} />
            </CardWrapper>
          ))}
        </CarouselContainer>
        <SeeAllButtonContainer>
          <SeeAllButton to="/services">See All Products</SeeAllButton>
        </SeeAllButtonContainer>
      </ProductsWrapper>
    </ProductsContainer>
  );
};

export default Content;